<h2>Outils</h2>
<div class="row card-communication bg-white pb-3 pt-3">
    <div class="col text-center">
        <button class="style-btn-bubble" [disabled]="!accees" data-toggle="modal" data-target="#ModelEmail" (click)="getListModelCommunication('M')">
      <div class="d-flex flex-column">
        <div class="logo-bubble mt-4">
          <img class="position-bubble background-bubble-Email" alt="" />
        </div>
        <div class="text-center">
          <p>Email</p>
        </div>
      </div>
    </button>
    </div>

    <div class="col text-center" *ngIf="fromtype == 'O'">
        <button class="style-btn-bubble" [disabled]="!accees" data-toggle="modal" data-target="#ModelVisio" (click)="goToPlanification()">
      <div class="d-flex flex-column">
        <div class="logo-bubble mt-4">
          <img class="position-bubble background-bubble-Visio" alt="" />
        </div>
        <div class="text-center">
          <p>Visio</p>
        </div>
      </div>
    </button>
    </div>
    <div class="col text-center">
        <button class="style-btn-bubble" [disabled]="!accees" data-toggle="modal" data-target="#ModelCourrier" (click)="getListModelCommunication('C')">
      <div class="d-flex flex-column">
        <div class="logo-bubble mt-4">
          <img class="position-bubble background-bubble-Courrier" alt="" />
        </div>
        <div class="text-center">
          <p>Courrier</p>
        </div>
      </div>
    </button>
    </div>
    <div class="col text-center">
        <button class="style-btn-bubble" [disabled]="!accees" data-toggle="modal" data-target="#ModelSMS" (click)="getListModelCommunication('S')">
      <div class="d-flex flex-column">
        <div class="logo-bubble mt-4">
          <img class="position-bubble background-bubble-SMS" alt="" />
        </div>
        <div class="text-center">
          <p>SMS</p>
        </div>
      </div>
    </button>
    </div>
</div>
<!-----------------------------Email Model------------------------------------>
<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="ModelEmail" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header  d-flex align-items-center justify-content-center">
                <p class="modal-title title m-0 text-center w-100">Nouveau Email</p>
                <button type="button" class="close" (click)="resetForm()" #closebuttonMail data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>

            <ng-container>
                <div class="modal-body">
                    <h3 class="text-center subTitle">Sélectionner un modèle</h3>
                    <ng-container *ngIf="show_loading">
                        <div class="row mb-3 mt-3">
                            <div class="text-center m-auto">
                                <mat-spinner [diameter]="30"></mat-spinner>
                            </div>
                        </div>
                    </ng-container>
                    <div class="row scroll" id="ex1" *ngIf="!show_loading">
                        <div class="col">
                            <ul>
                                <li class="nav-item dropdown" *ngFor="let model of communicationModel; let i = index">
                                    <ng-container *ngIf="model.childs.length > 0">

                                        <a href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class=" row dropdown-toggle btn-style dropbtn">
                                           
                                                {{ expandFileName(model.nom) }}
                                          
                      
                    </a>
                                        <ng-container *ngTemplateOutlet="dropdownList; context: { menu: model }"></ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="model.childs.length < 1">
                                        <ng-container *ngTemplateOutlet="defaultBtnModel; context: { menu: model }"></ng-container>
                                    </ng-container>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <p *ngIf="communicationModel.length < 1 && !show_loading" class="small font-weight-bold text-center">
                        Pas de modèle disponible
                    </p>
                    <div *ngIf="libelle_categorie !== ''">
                        <label> Modèle : {{ libelle_categorie }}</label>
                    </div>

                    <form [formGroup]="formModel" (ngSubmit)="SendEmail()">
                        <div class="form-group">
                            <mat-form-field class="w-100" appearance="standard">
                                <mat-label>Vers</mat-label>
                                <input type="text " matInput formControlName="mail_destinataire" pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" name="mail_destinataire" required />
                            </mat-form-field>
                            <div *ngIf="
                  !formModel.get('mail_destinataire').valid &&
                  (formModel.get('mail_destinataire').dirty || formModel.get('mail_destinataire').touched)
                ">
                                <div *ngIf="formModel.get('mail_destinataire').hasError('required')" class="message-erreur">
                                    <fa-icon [icon]="fa['faExclamationTriangle']"></fa-icon>
                                    Email est obligatoire
                                </div>
                                <div *ngIf="formModel.get('mail_destinataire').hasError('pattern')" class="message-erreur">
                                    <fa-icon [icon]="fa['faExclamationTriangle']"></fa-icon>
                                    Format email est invalide (exemple: email@email.com)
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <mat-form-field class="w-100" appearance="standard">
                                <mat-label>Sujet</mat-label>
                                <input type="text " matInput formControlName="sujet_mail" name="sujet_mail" required />
                            </mat-form-field>
                            <div *ngIf="
                  !formModel.get('sujet_mail').valid &&
                  (formModel.get('sujet_mail').dirty || formModel.get('sujet_mail').touched)
                " class="message-erreur">
                                <fa-icon [icon]="fa['faExclamationTriangle']"></fa-icon>
                                Le sujet est obligatoire!
                            </div>
                        </div>

                        <mat-tab-group (selectedTabChange)="preview()" mat-align-tabs="center" style="z-index: 0">
                            <mat-tab label="Écrire ">
                                <ckeditor [config]="config" class="w-100 mt-3" name="body_content_mail " data="{{ contentBody }}" (change)="getValueFromEditor($event)" formControlName="body_content_mail" [editor]="Editor">
                                </ckeditor>
                            </mat-tab>
                            <mat-tab label="Aperçu ">
                                <ng-container *ngIf="show_loading_prev">
                                    <div class="col-12">
                                        <div class="spinner-style">
                                            <mat-spinner [diameter]="30"></mat-spinner>
                                        </div>
                                    </div>
                                </ng-container>
                                <ckeditor [config]="config" class="w-100 mt-3" name="preview" formControlName="preview" [editor]="Editor" [disabled]="true">
                                </ckeditor>
                            </mat-tab>
                        </mat-tab-group>

                        <div class="form-group text-right">
                            <ng-container *ngIf="ListFiles.length > 0">
                                <div class="row">
                                    <div class="col-2 file-selected-style" *ngFor="let file of ListFiles; let index = index">
                                        <div class="row">
                                            <div class="col-2 delete-btn" (click)="dropFile(index)">
                                                <fa-icon [icon]="fa['faTrash']"></fa-icon>
                                            </div>
                                            <div class="col-10">
                                                {{ expandFileName(file.name) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <div class="modal-footer">
                            <div class="row d-flex justify-content-center  w-100">
                                <div class="col-6 d-flex justify-content-center ">
                                    <ng-container *ngIf="show_loading_add">
                                      
                                            <div class="spinner-style">
                                                <mat-spinner [diameter]="30"></mat-spinner>
                                            </div>
                                        
                                    </ng-container>
                                </div></div>
                                <div class="row d-flex justify-content-center w-100">
                            
                          
                                        <button class="btn-dt-save-popup mt-1 mr-2" type="submit">
                                            <fa-icon class="fa-lg" [icon]="fa['faCheckCircle']"></fa-icon>&nbsp; Enregistrer
                                          </button> 
                                    <button class="btn-dt-cancel-popup mt-1 ml-2" type="button" (click)="resetForm()" #closebutton data-dismiss="modal">
                    <fa-icon class="fa-lg" [icon]="fa['faTimesCircle']"></fa-icon>&nbsp; Annuler
                  </button>
                  </div>

                              
                    
                        
                        </div>
                    </form>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<!-----------------------------Courrier Model------------------------------------>
<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="ModelCourrier" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" style="left: 75px">
        <div class="modal-content">
            <div class="modal-header  d-flex align-items-center justify-content-center">
                <p class="modal-title title m-0 text-center w-100">Nouveau Courrier</p>
                <button type="button" class="close" #closeModal (click)="resetForm()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body p-0">
                <app-add-maileva *ngIf="prospect?.mainProspect?.id" [id_prospect]="prospect?.mainProspect?.id" [id_opportunite]="id_opportunite" [affaire_id]="affaire_id" [fromDetails]="fromDetails" [fromtype]="fromtype"></app-add-maileva>
            </div>
        </div>
    </div>
</div>

<!-----------------------------SMS Model------------------------------------>
<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="ModelSMS" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header  d-flex align-items-center justify-content-center">
                <p class="modal-title title m-0 text-center w-100">Nouveau SMS</p>
                <button type="button" class="close" (click)="resetForm()" #closebuttonSMS data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <form [formGroup]="formModel" (ngSubmit)="sendSMS()">
                <div class="modal-body">
                    <h3 class="text-center subTitle">Sélectionner un modèle</h3>
                    <ng-container *ngIf="show_loading">
                        <div class="row mb-3 mt-3">
                            <div class="text-center m-auto">
                                <mat-spinner [diameter]="30"></mat-spinner>
                            </div>
                        </div>
                    </ng-container>
                    <div class="row scroll" id="ex2" *ngIf="!show_loading">
                        <div class="col">
                            <ul>
                                <li class="nav-item dropdown" *ngFor="let model of communicationModel; let i = index">
                                    <ng-container *ngIf="model.childs.length > 0">
                                        <a href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="row iconSetting  btn-style dropbtn">
                                            <div class="col-2 ">
                                                <svg width="14" height="14" viewBox="0 0 14 14"  xmlns="http://www.w3.org/2000/svg">
                                                    <g id="wrapper" clip-path="url(#clip0_2647_22960)">
                                                    <path id="Union"  d="M13.4531 8.77891L12.4297 7.90391C12.4781 7.60703 12.5031 7.30391 12.5031 7.00078C12.5031 6.69766 12.4781 6.39453 12.4297 6.09766L13.4531 5.22266C13.5303 5.15657 13.5856 5.06856 13.6115 4.97031C13.6375 4.87206 13.6329 4.76824 13.5984 4.67266L13.5844 4.63203C13.3026 3.84457 12.8807 3.11459 12.3391 2.47734L12.3109 2.44453C12.2452 2.36727 12.1577 2.31173 12.0597 2.28523C11.9618 2.25873 11.8582 2.26252 11.7625 2.29609L10.4922 2.74766C10.0234 2.36328 9.5 2.06016 8.93438 1.84766L8.68907 0.519531C8.67056 0.419597 8.62208 0.32766 8.55008 0.255934C8.47807 0.184208 8.38595 0.136089 8.28594 0.117969L8.24375 0.110156C7.42969 -0.0367187 6.57344 -0.0367187 5.75938 0.110156L5.71719 0.117969C5.61719 0.136089 5.52506 0.184208 5.45306 0.255934C5.38105 0.32766 5.33257 0.419597 5.31407 0.519531L5.06719 1.85391C4.50608 2.06645 3.98354 2.36941 3.52032 2.75078L2.24063 2.29609C2.14495 2.26225 2.04124 2.25833 1.94328 2.28484C1.84531 2.31136 1.75774 2.36705 1.69219 2.44453L1.66407 2.47734C1.12304 3.11504 0.701216 3.8449 0.418753 4.63203L0.404691 4.67266C0.334378 4.86797 0.392191 5.08672 0.550003 5.22266L1.58594 6.10703C1.5375 6.40078 1.51407 6.70078 1.51407 6.99922C1.51407 7.29922 1.5375 7.59922 1.58594 7.89141L0.550003 8.77578C0.472809 8.84187 0.41756 8.92988 0.391603 9.02813C0.365646 9.12637 0.370211 9.23019 0.404691 9.32578L0.418753 9.36641C0.701566 10.1539 1.12032 10.8805 1.66407 11.5211L1.69219 11.5539C1.7579 11.6312 1.84548 11.6867 1.94338 11.7132C2.04129 11.7397 2.14492 11.7359 2.24063 11.7023L3.52032 11.2477C3.98594 11.6305 4.50625 11.9336 5.06719 12.1445L5.31407 13.4789C5.33257 13.5788 5.38105 13.6708 5.45306 13.7425C5.52506 13.8142 5.61719 13.8623 5.71719 13.8805L5.75938 13.8883C6.58092 14.0359 7.42221 14.0359 8.24375 13.8883L8.28594 13.8805C8.38595 13.8623 8.47807 13.8142 8.55008 13.7425C8.62208 13.6708 8.67056 13.5788 8.68907 13.4789L8.93438 12.1508C9.49977 11.9388 10.0262 11.6347 10.4922 11.2508L11.7625 11.7023C11.8582 11.7362 11.9619 11.7401 12.0599 11.7136C12.1578 11.6871 12.2454 11.6314 12.3109 11.5539L12.3391 11.5211C12.8828 10.8789 13.3016 10.1539 13.5844 9.36641L13.5984 9.32578C13.6688 9.13359 13.6109 8.91484 13.4531 8.77891ZM11.3203 6.28203C11.3594 6.51797 11.3797 6.76016 11.3797 7.00234C11.3797 7.24453 11.3594 7.48672 11.3203 7.72266L11.2172 8.34922L12.3844 9.34766C12.2074 9.7553 11.9841 10.1412 11.7188 10.4977L10.2688 9.98359L9.77813 10.3867C9.40469 10.693 8.98907 10.9336 8.53907 11.1023L7.94375 11.3258L7.66407 12.8414C7.22277 12.8914 6.77724 12.8914 6.33594 12.8414L6.05625 11.3227L5.46563 11.0961C5.02032 10.9273 4.60625 10.6867 4.23594 10.382L3.74532 9.97734L2.28594 10.4961C2.02032 10.1383 1.79844 9.75234 1.62032 9.34609L2.8 8.33828L2.69844 7.71328C2.66094 7.48047 2.64063 7.23984 2.64063 7.00234C2.64063 6.76328 2.65938 6.52422 2.69844 6.29141L2.8 5.66641L1.62032 4.65859C1.79688 4.25078 2.02032 3.86641 2.28594 3.50859L3.74532 4.02734L4.23594 3.62266C4.60625 3.31797 5.02032 3.07734 5.46563 2.90859L6.05782 2.68516L6.3375 1.16641C6.77657 1.11641 7.225 1.11641 7.66563 1.16641L7.94532 2.68203L8.54063 2.90547C8.98907 3.07422 9.40625 3.31484 9.77969 3.62109L10.2703 4.02422L11.7203 3.51016C11.9859 3.86797 12.2078 4.25391 12.3859 4.66016L11.2188 5.65859L11.3203 6.28203ZM7.00313 4.09609C5.48438 4.09609 4.25313 5.32734 4.25313 6.84609C4.25313 8.36484 5.48438 9.59609 7.00313 9.59609C8.52188 9.59609 9.75313 8.36484 9.75313 6.84609C9.75313 5.32734 8.52188 4.09609 7.00313 4.09609ZM8.24063 8.08359C8.07832 8.24637 7.88543 8.37545 7.67305 8.4634C7.46067 8.55136 7.233 8.59645 7.00313 8.59609C6.53594 8.59609 6.09688 8.41328 5.76563 8.08359C5.60285 7.92128 5.47377 7.72839 5.38582 7.51601C5.29787 7.30364 5.25277 7.07596 5.25313 6.84609C5.25313 6.37891 5.43594 5.93984 5.76563 5.60859C6.09688 5.27734 6.53594 5.09609 7.00313 5.09609C7.47032 5.09609 7.90938 5.27734 8.24063 5.60859C8.4034 5.7709 8.53248 5.9638 8.62044 6.17617C8.70839 6.38855 8.75349 6.61622 8.75313 6.84609C8.75313 7.31328 8.57032 7.75234 8.24063 8.08359Z" />
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_2647_22960">
                                                    <rect width="14" height="14" />
                                                    </clipPath>
                                                    </defs>
                                                    </svg>
                                                    
                                            </div>
                                            <div class="col-10 text-left">
                                                {{ expandFileName(model.nom) }}
                                                <span class="dropdown-toggle text-right"></span>
                                               </div> 

                  
                    </a>
                                        <ng-container *ngTemplateOutlet="dropdownList; context: { menu: model }"></ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="model.childs.length < 1">
                                        <ng-container *ngTemplateOutlet="defaultBtnModel; context: { menu: model }"></ng-container>
                                    </ng-container>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <p *ngIf="communicationModel.length < 1 && !show_loading" class="small font-weight-bold text-center">
                        Pas de modèle disponible
                    </p>
                    <div *ngIf="libelle_categorie !== ''">
                        <label> Modèle : {{ libelle_categorie }}</label>
                    </div>

                    <h4 class="col-form-label text-center subTitle ">Paramètres SMS:</h4>

                    <div class="form-group">
                        <mat-form-field class="w-100" appearance="{{ appearance }}" floatLabel="always">
                            <mat-label class="ng2tel-field-label">Téléphone</mat-label>
                            <input (keypress)="numberOnly($event)" ng2TelInput matInput name="telephone_destinataire" class="full_width" maxlength="15" min="2" formControlName="telephone_destinataire" [ng2TelInputOptions]="{ initialCountry: telCountry }" (hasError)="hasError($event)"
                            />
                            <fa-icon matSuffix [icon]="fa['faPhone']"></fa-icon>
                        </mat-form-field>
                        <div *ngIf="
                !formModel.get('telephone_destinataire').valid &&
                (formModel.get('telephone_destinataire').dirty || formModel.get('telephone_destinataire').touched)
              ">
                            <div *ngIf="formModel.get('telephone_destinataire').hasError('required')" class="message-erreur">
                                <fa-icon [icon]="fa['faExclamationTriangle']"></fa-icon>
                                Téléphone est obligatoire !
                            </div>
                            <div *ngIf="formModel.get('telephone_destinataire').hasError('pattern')" class="message-erreur">
                                <fa-icon [icon]="fa['faExclamationTriangle']"></fa-icon>
                                Merci de saisir un numéro de téléphone valide
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <mat-form-field class="w-100" appearance="standard">
                            <mat-label>Sujet</mat-label>
                            <input type="text" matInput formControlName="sujet_sms" name="sujet_sms" required />
                        </mat-form-field>
                        <div *ngIf="
                !formModel.get('sujet_sms').valid &&
                (formModel.get('sujet_sms').dirty || formModel.get('sujet_sms').touched)
              " class="message-erreur">
                            <fa-icon [icon]="fa['faExclamationTriangle']"></fa-icon>
                            Le sujet est obligatoire!
                        </div>
                    </div>
                    <mat-tab-group (selectedTabChange)="preview()" mat-align-tabs="center" style="z-index: 0">
                        <mat-tab label="Écrire">
                            <ckeditor [config]="config" class="w-100 mt-3" name="body_content_sms" formControlName="body_content_sms" data="{{ contentBody }}" (change)="getValueFromEditor($event)" [editor]="Editor"></ckeditor>
                        </mat-tab>
                        <mat-tab label="Aperçu">
                            <ng-container *ngIf="show_loading_prev">
                                <div class="col-12">
                                    <div class="spinner-style">
                                        <mat-spinner [diameter]="30"></mat-spinner>
                                    </div>
                                </div>
                            </ng-container>
                            <ckeditor [config]="config" class="w-100 mt-3" name="preview" formControlName="preview" [editor]="Editor" [disabled]="true">
                            </ckeditor>
                        </mat-tab>
                    </mat-tab-group>
                    <div class="form-group"></div>
                </div>
                <div class="modal-footer">
                    <div class="row w-100 d-flex justify-content-center">
                        <div class="col-6 d-flex justify-content-center">
                            <ng-container *ngIf="show_loading_add">
                             
                                    <div class="spinner-style">
                                        <mat-spinner [diameter]="30"></mat-spinner>
                                    </div>
                                
                            </ng-container>
                        </div>
                        </div>
                        <div class="row w-100 d-flex justify-content-center ">
                  
                            <button class="btn-dt-save-popup mr-2" type="submit">
                                <fa-icon class="fa-lg" [icon]="fa['faCheckCircle']"></fa-icon>&nbsp; Enregistrer
                              </button>

                            <button class="btn-dt-cancel-popup ml-2 " type="button" (click)="resetForm()" #closebutton data-dismiss="modal">
                <fa-icon class="fa-lg" [icon]="fa['faTimesCircle']"></fa-icon>&nbsp; Annuler
              </button>
               
          
                  
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<!-----------------------------Ajouter Model------------------------------------>
<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="ModelAjouter" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title"></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            ...
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Fermer</button>
                <button type="button" class="btn btn-primary">Envoyer</button>
            </div>
        </div>
    </div>
</div>
<ng-template #loading>
    <div class="col-12 text-center">
        <ng-container *ngIf="show_loading_add">
            <div class="d-flex justify-content-end">
                <div class="spinner-style">
                    <mat-spinner [diameter]="50"></mat-spinner>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>
<ng-template #dropdownList let-menuList="menu">
    <ul class="dropdown-menu border-0 shadow">
        <ng-container *ngFor="let menu of menuList.childs">
            <ng-container *ngIf="menu.childs.length > 0">
                <ng-container *ngTemplateOutlet="subMenu; context: { menu: menu }"></ng-container>
            </ng-container>
            <ng-container *ngIf="menu.childs.length < 1">
                <ng-container *ngTemplateOutlet="subElement; context: { menu: menu }"></ng-container>
            </ng-container>
        </ng-container>
    </ul>
</ng-template>

<ng-template #subElement let-element="menu">
    <li>
        <a (click)="
        closeAllDropDownElements($event);
        getInfoModel(element);
        setComValue(element.id);
        setCategorieValue(element.id, element.nom)
      " class="dropdown-item">{{ element.nom }}
    </a>
    </li>
</ng-template>

<ng-template #subMenu let-element="menu">
    <li class="dropdown-submenu">
        <a (click)="showSubMenu($event)" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-item ">{{ element.nom }}</a
    >
    <ng-container *ngTemplateOutlet="dropdownList; context: { menu: element }"></ng-container>
  </li>
</ng-template>
<ng-template #defaultBtnModel let-model="menu">
  <a
    (click)="getInfoModel(model); setCategorieValue(model.id, model.nom)"
    aria-haspopup="true"
    aria-expanded="false"
    class="row btn-style dropbtn iconSetting"
 
  >
  <div class="col-2 ">
    <svg width="14" height="14" viewBox="0 0 14 14"  xmlns="http://www.w3.org/2000/svg">
        <g id="wrapper" clip-path="url(#clip0_2647_22960)">
        <path id="Union"  d="M13.4531 8.77891L12.4297 7.90391C12.4781 7.60703 12.5031 7.30391 12.5031 7.00078C12.5031 6.69766 12.4781 6.39453 12.4297 6.09766L13.4531 5.22266C13.5303 5.15657 13.5856 5.06856 13.6115 4.97031C13.6375 4.87206 13.6329 4.76824 13.5984 4.67266L13.5844 4.63203C13.3026 3.84457 12.8807 3.11459 12.3391 2.47734L12.3109 2.44453C12.2452 2.36727 12.1577 2.31173 12.0597 2.28523C11.9618 2.25873 11.8582 2.26252 11.7625 2.29609L10.4922 2.74766C10.0234 2.36328 9.5 2.06016 8.93438 1.84766L8.68907 0.519531C8.67056 0.419597 8.62208 0.32766 8.55008 0.255934C8.47807 0.184208 8.38595 0.136089 8.28594 0.117969L8.24375 0.110156C7.42969 -0.0367187 6.57344 -0.0367187 5.75938 0.110156L5.71719 0.117969C5.61719 0.136089 5.52506 0.184208 5.45306 0.255934C5.38105 0.32766 5.33257 0.419597 5.31407 0.519531L5.06719 1.85391C4.50608 2.06645 3.98354 2.36941 3.52032 2.75078L2.24063 2.29609C2.14495 2.26225 2.04124 2.25833 1.94328 2.28484C1.84531 2.31136 1.75774 2.36705 1.69219 2.44453L1.66407 2.47734C1.12304 3.11504 0.701216 3.8449 0.418753 4.63203L0.404691 4.67266C0.334378 4.86797 0.392191 5.08672 0.550003 5.22266L1.58594 6.10703C1.5375 6.40078 1.51407 6.70078 1.51407 6.99922C1.51407 7.29922 1.5375 7.59922 1.58594 7.89141L0.550003 8.77578C0.472809 8.84187 0.41756 8.92988 0.391603 9.02813C0.365646 9.12637 0.370211 9.23019 0.404691 9.32578L0.418753 9.36641C0.701566 10.1539 1.12032 10.8805 1.66407 11.5211L1.69219 11.5539C1.7579 11.6312 1.84548 11.6867 1.94338 11.7132C2.04129 11.7397 2.14492 11.7359 2.24063 11.7023L3.52032 11.2477C3.98594 11.6305 4.50625 11.9336 5.06719 12.1445L5.31407 13.4789C5.33257 13.5788 5.38105 13.6708 5.45306 13.7425C5.52506 13.8142 5.61719 13.8623 5.71719 13.8805L5.75938 13.8883C6.58092 14.0359 7.42221 14.0359 8.24375 13.8883L8.28594 13.8805C8.38595 13.8623 8.47807 13.8142 8.55008 13.7425C8.62208 13.6708 8.67056 13.5788 8.68907 13.4789L8.93438 12.1508C9.49977 11.9388 10.0262 11.6347 10.4922 11.2508L11.7625 11.7023C11.8582 11.7362 11.9619 11.7401 12.0599 11.7136C12.1578 11.6871 12.2454 11.6314 12.3109 11.5539L12.3391 11.5211C12.8828 10.8789 13.3016 10.1539 13.5844 9.36641L13.5984 9.32578C13.6688 9.13359 13.6109 8.91484 13.4531 8.77891ZM11.3203 6.28203C11.3594 6.51797 11.3797 6.76016 11.3797 7.00234C11.3797 7.24453 11.3594 7.48672 11.3203 7.72266L11.2172 8.34922L12.3844 9.34766C12.2074 9.7553 11.9841 10.1412 11.7188 10.4977L10.2688 9.98359L9.77813 10.3867C9.40469 10.693 8.98907 10.9336 8.53907 11.1023L7.94375 11.3258L7.66407 12.8414C7.22277 12.8914 6.77724 12.8914 6.33594 12.8414L6.05625 11.3227L5.46563 11.0961C5.02032 10.9273 4.60625 10.6867 4.23594 10.382L3.74532 9.97734L2.28594 10.4961C2.02032 10.1383 1.79844 9.75234 1.62032 9.34609L2.8 8.33828L2.69844 7.71328C2.66094 7.48047 2.64063 7.23984 2.64063 7.00234C2.64063 6.76328 2.65938 6.52422 2.69844 6.29141L2.8 5.66641L1.62032 4.65859C1.79688 4.25078 2.02032 3.86641 2.28594 3.50859L3.74532 4.02734L4.23594 3.62266C4.60625 3.31797 5.02032 3.07734 5.46563 2.90859L6.05782 2.68516L6.3375 1.16641C6.77657 1.11641 7.225 1.11641 7.66563 1.16641L7.94532 2.68203L8.54063 2.90547C8.98907 3.07422 9.40625 3.31484 9.77969 3.62109L10.2703 4.02422L11.7203 3.51016C11.9859 3.86797 12.2078 4.25391 12.3859 4.66016L11.2188 5.65859L11.3203 6.28203ZM7.00313 4.09609C5.48438 4.09609 4.25313 5.32734 4.25313 6.84609C4.25313 8.36484 5.48438 9.59609 7.00313 9.59609C8.52188 9.59609 9.75313 8.36484 9.75313 6.84609C9.75313 5.32734 8.52188 4.09609 7.00313 4.09609ZM8.24063 8.08359C8.07832 8.24637 7.88543 8.37545 7.67305 8.4634C7.46067 8.55136 7.233 8.59645 7.00313 8.59609C6.53594 8.59609 6.09688 8.41328 5.76563 8.08359C5.60285 7.92128 5.47377 7.72839 5.38582 7.51601C5.29787 7.30364 5.25277 7.07596 5.25313 6.84609C5.25313 6.37891 5.43594 5.93984 5.76563 5.60859C6.09688 5.27734 6.53594 5.09609 7.00313 5.09609C7.47032 5.09609 7.90938 5.27734 8.24063 5.60859C8.4034 5.7709 8.53248 5.9638 8.62044 6.17617C8.70839 6.38855 8.75349 6.61622 8.75313 6.84609C8.75313 7.31328 8.57032 7.75234 8.24063 8.08359Z" />
        </g>
        <defs>
        <clipPath id="clip0_2647_22960">
        <rect width="14" height="14" />
        </clipPath>
        </defs>
        </svg>
        
</div>
<div class="col-10 text-left">
    {{ expandFileName(model.nom) }}
    <!-- <span class="dropdown-toggle text-right"></span> -->
   </div> 
  </a>
</ng-template>
